import { useEffect } from 'react';
import type { PaymentLayoutProps } from '../../../common';
import { PaymentPage } from '../payment';
import { useCheckoutNavigation } from '../providers';
import { SuccessMessage } from './success-message';

export function PaymentLayout({
  paymentPageSettings,
  successMessageSettings
}: PaymentLayoutProps) {
  const { checkoutStep, setCheckoutStep } = useCheckoutNavigation();

  useEffect(() => {
    setCheckoutStep('payment');
  }, [paymentPageSettings, setCheckoutStep]);

  if (checkoutStep === 'payment') {
    return <PaymentPage {...paymentPageSettings} />;
  }

  if (checkoutStep === 'success') {
    return <SuccessMessage {...successMessageSettings} />;
  }

  return null;
}
